import type { ReminderMarkDotKind } from './ReminderMarkDot'

export const REMINDER_SCHEDULE_ADMIN_ROLES = new Set(['ADMIN', 'OWNER'])

export const REMINDER_SETTINGS_PATH = '/settings/organization/reminders' as const

// #region Tone classes (light + dark)
export const AMBER_NOTICE_CLASSES =
  'border-amber-200 bg-amber-50 text-amber-800 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-300'
export const BLUE_PANEL_CLASSES =
  'bg-sky-50 text-sky-950 dark:bg-sky-950/40 dark:text-sky-100'
export const AMBER_CHIP_CLASSES =
  'bg-amber-50 text-amber-800 dark:bg-amber-950/50 dark:text-amber-300'
export const BLUE_CHIP_CLASSES =
  'bg-sky-50 text-sky-800 dark:bg-sky-950/50 dark:text-sky-200'
// #endregion

/** What each timeline dot means, shown on hover and read out in tables. */
export const REMINDER_MARK_DOT_LABELS: Record<ReminderMarkDotKind, string> = {
  email: 'Email to client',
  alert: 'Alert to you only',
  emailAndAlert: 'Email to client and alert to you',
  repeat: 'Repeat email to client',
}

/** One line on what a step of each kind does, shown under its label in tooltips. */
export const REMINDER_MARK_DOT_DESCRIPTIONS: Record<ReminderMarkDotKind, string> = {
  email: 'Emails the client a payment reminder.',
  alert: 'Sends you an alert only. The client is not emailed.',
  emailAndAlert: 'Emails the client a payment reminder and sends you an alert.',
  repeat:
    'Emails the client again after the last reminder, until the invoice is paid or the repeats run out.',
}

export const REMINDER_START_NOTE =
  'Reminders start when the invoice is emailed. Any step whose date has already passed at that moment is skipped.'

export const reminderSendTimeNote = (timezoneCity: string) =>
  `Sent from 9:00 am ${timezoneCity} time (your organisation timezone).`

export const REMINDER_CHANGES_NOTE =
  'Changes will apply to invoices sent with the most recent updates.'
